import { createFileRoute } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';
import { DataSyncPage } from '@/pages/organization-settings/data-sync/DataSyncPage';

export const Route = createFileRoute('/$slug/organization-settings/data-sync')({
  beforeLoad: createCaslGuard('DataSync', 'update'),
  component: DataSyncPage
});
